import { Box, Typography } from "@mui/material";
import React, { ReactNode, Suspense } from "react";
import { SubmitHandler, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import CustomLoader from "src/shared_components/CustomLoader";
import PermissionRestrictedComponent from "src/shared_components/PermissionRestrictedComponent";
import AddClearButtons from "./buttons/AddClearButtons";

interface EditPageWrapperProps {
  children: ReactNode;
  id?: number;
  editTitle: string;
  addTitle: string;
  loading?: boolean;
  createOrModifyPermission?: number;
  onSubmit: SubmitHandler<any>;
  isSubmitBtn?: boolean;
  titleComponent?: any;
  handleArrowClick?: (event?: React.MouseEvent<HTMLElement>) => void;
}

const EditPageWrapper: React.FC<EditPageWrapperProps> = ({
  children,
  id,
  editTitle,
  addTitle,
  loading,
  createOrModifyPermission,
  onSubmit,
  isSubmitBtn = true,
  titleComponent,
  handleArrowClick,
}) => {
  const { t } = useTranslation();
  const {
    handleSubmit,
    formState: { isSubmitting },
  } = useFormContext();

  return (
    <PermissionRestrictedComponent permission={createOrModifyPermission ?? 0}>
      <>
        {/* <BackButton handleClick={handleArrowClick}> */}
        {titleComponent ? (
          <Box component="div" mb={4}>
            {titleComponent}
          </Box>
        ) : (
          <Typography
            variant="h3"
            fontWeight={700}
            color="primary"
            sx={{
              fontSize: "45px",
              lineHeight: "42px",
            }}
            mb={4}
          >
            {id ? t(editTitle) : t(addTitle)}
          </Typography>
        )}
        {/* </BackButton> */}

        {loading ? (
          <CustomLoader />
        ) : (
          <Suspense fallback={<CustomLoader size={30} />}>
            <form onSubmit={handleSubmit(onSubmit)} autoComplete="off">
              {children}
              {isSubmitBtn && <AddClearButtons disabled={isSubmitting} />}
            </form>
          </Suspense>
        )}
      </>
    </PermissionRestrictedComponent>
  );
};

export default EditPageWrapper;
